import { NoResultsIcon } from '../../icons';
import { useIntl, useSelector } from '@topwrite/common';

export function NoResultsScreen() {

    const { query } = useSelector('search');
    const intl = useIntl();

    return (
        <div className='DocSearch-NoResults'>
            <div className='DocSearch-Screen-Icon'>
                <NoResultsIcon />
            </div>
            <p className='DocSearch-Title'>
                {intl.$t({ defaultMessage: '没有结果:' })} "<strong>{query}</strong>"
            </p>
        </div>
    );
}
